import URLSearchParams from 'core-js-pure/features/url-search-params';
import { IS_CLIENT } from '../constants';
/**
 * Get the URL parameters of the current URL
 * @returns {Object} params - a list of parameter objects
 * @returns {Object} params.key - Parameter key
 * @returns {Object} params.value - Parameter value
 */
const getUrlParams = () => {
    return IS_CLIENT ? Object.fromEntries(new URLSearchParams(window.location.search)) : null;
};
export default getUrlParams;
//# sourceMappingURL=getUrlParams.js.map